/* wb-pdp.js - Smart-Boards quote-only PDP v2. No libraries. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }
  ready(function () {

    /* ============================================================
       ANCHOR-JUMP KILLSWITCH - runs FIRST, before anything else and
       before any guard clause, so it applies even if this page has no
       .wb-pdp root and even if the stepper never initialises.

       Shopify renders {% form 'contact' %} with a default id of
       "contact_form" and action="/contact#contact_form" even when no id:
       parameter is passed. After a successful POST Shopify redirects back
       to the page carrying that fragment, and the browser anchor-jumps to
       the form. Stripping the fragment from the action attribute at
       runtime - before any submit can occur - means the POST target and
       Shopify's subsequent redirect never contain a fragment at all.

       Only the fragment is touched. Method, fields and hidden inputs are
       left exactly as rendered.
       ============================================================ */
    function stripActionHash() {
      try {
        [].slice.call(document.querySelectorAll('form[action*="/contact#"]')).forEach(function (f) {
          var a = f.getAttribute('action');
          if (a) { f.setAttribute('action', a.split('#')[0]); }
        });
      } catch (err) { /* no-op */ }
    }
    stripActionHash();

    /* Belt and braces: drop a stale #RfqForm / #contact_form fragment that is
       already in the URL (old links, bfcache restore) WITHOUT scrolling.
       history.replaceState never scrolls. */
    function stripHash() {
      try {
        var h = window.location.hash;
        if ((h === '#RfqForm' || h === '#contact_form') && window.history && window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname + window.location.search);
        }
      } catch (err) { /* no-op */ }
    }
    stripHash();
    window.addEventListener('pageshow', stripHash);

    /* ============================================================
       STANDARDISED EMAIL SUBJECT LINE

         Smart-Boards - {CODE} - {Country} - {Product Name} - {Customer Name}

       snippets/form-subject.liquid renders everything the server can know
       ("Smart-Boards - RFQ - {Country} - {Product Name}") into the hidden
       contact[subject] input. The visitor's typed name is only available in
       the browser, so it is appended here at submit time - after validation
       has passed and before the POST proceeds.

       The server-rendered prefix is cached in data-subject-base the first
       time this runs, so a second submit can never append the name twice.
       A blank name leaves the prefix exactly as rendered rather than adding
       a dangling " - ", and any trailing separator already present is
       removed before the name is appended.
       ============================================================ */
    function cleanSubjectPart(v) {
      return String(v == null ? '' : v).replace(/[\s ]+/g, ' ').replace(/^\s+|\s+$/g, '');
    }

    function setSubject(form) {
      try {
        if (!form || !form.querySelector) return;
        var subj = form.querySelector('input[name="contact[subject]"]');
        if (!subj) return;
        var base = subj.getAttribute('data-subject-base');
        if (base === null) { base = subj.value; subj.setAttribute('data-subject-base', base); }
        base = cleanSubjectPart(base).replace(/(?:\s*-\s*)+$/, '');
        var nameEl = form.querySelector('#RfqName, input[name="contact[Name]"], #ContactForm-name');
        var nm = nameEl ? cleanSubjectPart(nameEl.value) : '';
        subj.value = nm ? base + ' - ' + nm : base;
      } catch (err) { /* no-op */ }
    }
    window.wbFormSubject = setSubject;

    var root = document.querySelector('.wb-pdp');
    if (!root) return;

    var hdr = document.querySelector('.header-wrapper') || document.querySelector('.section-header') || document.querySelector('header');
    var bar = root.querySelector('.wb-minibar');
    var lead = root.querySelector('.wb-lead');

    function hdrBottom() {
      return hdr ? Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) : 0;
    }

    /* ---- gallery: thumbnail swaps the main image ---- */
    var main = root.querySelector('#wbGalMain');
    var thumbs = [].slice.call(root.querySelectorAll('.wb-gal__thumb'));
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!main) return;
        var full = b.getAttribute('data-full');
        if (full) { main.src = full; }
        var alt = b.getAttribute('data-alt');
        if (alt) { main.alt = alt; }
        thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });

    /* ---- variant select (quote-only: updates SKU + hidden form fields) ---- */
    var vs = root.querySelector('#wbVariant');
    if (vs) {
      vs.addEventListener('change', function () {
        var o = vs.options[vs.selectedIndex];
        var sku = o.getAttribute('data-sku') || '';
        var chip = root.querySelector('.wb-chip--sku');
        if (chip) { chip.textContent = 'SKU: ' + sku; chip.hidden = !sku; }
        var hs = root.querySelector('input[name="contact[SKU]"]');
        if (hs) { hs.value = sku; }
        var hv = root.querySelector('input[name="contact[Variant]"]');
        if (hv) { hv.value = o.value; }
      });
    }

    /* ============================================================
       RFQ stepper - one question at a time.
       PROGRESSIVE ENHANCEMENT: the Liquid renders every field
       visible in a plain 2-column form that submits normally. This
       block runs only if JS is alive; it adds .is-stepped to the
       form and hides all but the active step with the `hidden`
       attribute (so hidden steps are never keyboard-focusable).
       Nothing is ever removed from the DOM, so the single
       {% form 'contact' %} still posts every field at once.

       NOTE: the form is selected by .wb-lead__form, NOT by #RfqForm.
       #RfqForm is the id of the .wb-lead WRAPPER. The form's own
       action fragment is stripped by stripActionHash() above.
       ============================================================ */
    (function stepper() {
      var form = root.querySelector('.wb-lead__form');
      if (!form || form.tagName !== 'FORM') return;

      var steps = [].slice.call(form.querySelectorAll('[data-wb-step]'));
      if (steps.length < 2) return; /* e.g. the thank-you state: no fields at all */

      var prog = form.querySelector('[data-wb-prog]');
      var fill = prog ? prog.querySelector('.wb-prog__fill') : null;
      var ptxt = prog ? prog.querySelector('.wb-prog__txt') : null;
      var next = form.querySelector('[data-wb-next]');
      var submit = form.querySelector('[data-wb-submit]');
      var foot = form.querySelector('[data-wb-foot]');
      var back = form.querySelector('[data-wb-back]');
      var skip = form.querySelector('[data-wb-skip]');
      if (!next || !submit) return;

      var total = steps.length;
      var idx = 0;
      var EMAIL = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;

      function fieldOf(s) { return s.querySelector('input, textarea'); }
      function errOf(s) { return s.querySelector('.wb-step__err'); }
      function isOptional(s) { return s.hasAttribute('data-wb-optional'); }

      function clearError(s) {
        var f = fieldOf(s), e = errOf(s);
        if (e) { e.textContent = ''; }
        if (f) { f.removeAttribute('aria-invalid'); }
        s.classList.remove('has-error');
      }

      function showError(s) {
        var f = fieldOf(s), e = errOf(s);
        if (e) { e.textContent = s.getAttribute('data-wb-error') || ''; }
        if (f) { f.setAttribute('aria-invalid', 'true'); }
        s.classList.add('has-error');
      }

      function isValid(s) {
        if (isOptional(s)) return true;
        var f = fieldOf(s);
        if (!f) return true;
        var val = (f.value || '').replace(/^\s+|\s+$/g, '');
        if (!val) return false;
        if (s.getAttribute('data-wb-type') === 'email') { return EMAIL.test(val); }
        return true;
      }

      function focusField(s) {
        var f = fieldOf(s);
        if (!f) return;
        try { f.focus({ preventScroll: true }); } catch (err) { f.focus(); }
      }

      function paint(focus) {
        var last = idx === total - 1;
        steps.forEach(function (s, i) {
          if (i === idx) {
            s.hidden = false;
            s.classList.remove('is-in');
            void s.offsetWidth; /* reflow so the 150ms fade/slide replays */
            s.classList.add('is-in');
          } else {
            s.hidden = true;
            s.classList.remove('is-in');
            clearError(s);
          }
        });
        next.hidden = last;
        submit.hidden = !last;
        if (back) { back.hidden = idx === 0; }
        if (skip) { skip.hidden = !(isOptional(steps[idx]) && !last); }
        if (foot) {
          foot.hidden = (!back || back.hidden) && (!skip || skip.hidden);
        }
        if (fill) {
          fill.style.setProperty('inline-size', Math.round(((idx + 1) / total) * 100) + '%');
        }
        if (ptxt && prog) {
          var pat = prog.getAttribute('data-wb-pattern') || 'Step {n} of {t}';
          ptxt.textContent = pat.replace('{n}', String(idx + 1)).replace('{t}', String(total));
        }
        if (focus) { focusField(steps[idx]); }
      }

      function go(i, focus) {
        if (i < 0) { i = 0; }
        if (i > total - 1) { i = total - 1; }
        idx = i;
        paint(focus);
      }

      function advance() {
        var s = steps[idx];
        if (!isValid(s)) {
          showError(s);
          focusField(s);
          return false;
        }
        clearError(s);
        if (idx < total - 1) { go(idx + 1, true); }
        return true;
      }

      next.addEventListener('click', function () { advance(); });
      if (back) { back.addEventListener('click', function () { go(idx - 1, true); }); }
      if (skip) {
        skip.addEventListener('click', function () { clearError(steps[idx]); go(idx + 1, true); });
      }

      steps.forEach(function (s) {
        var f = fieldOf(s);
        if (!f) return;
        f.addEventListener('input', function () {
          if (s.classList.contains('has-error')) { clearError(s); }
        });
        /* Enter advances instead of submitting early - textareas keep newlines. */
        if (f.tagName === 'TEXTAREA') return;
        f.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.keyCode !== 13) return;
          e.preventDefault();
          advance();
        });
      });

      /* Final guard: never post with a required step empty.
         Once validation has passed, stamp the customer name onto
         contact[subject], then re-strip the action fragment right before the
         POST leaves, in case anything re-rendered the form after load. */
      form.addEventListener('submit', function (e) {
        for (var i = 0; i < total; i++) {
          if (!isValid(steps[i])) {
            e.preventDefault();
            go(i, true);
            showError(steps[i]);
            return;
          }
        }
        setSubject(form);
        stripActionHash();
      });

      /* ---- collapse into steps ---- */
      form.noValidate = true; /* JS owns validation; avoids "not focusable" on hidden required fields */
      form.classList.add('is-stepped');
      if (prog) { prog.hidden = false; }

      /* After a failed Shopify post, reopen at the first step that still
         needs attention (values Shopify preserved are kept); otherwise the
         last step so the visitor can retry the submit straight away. */
      var start = 0;
      if (form.querySelector('.wb-err')) {
        start = total - 1;
        for (var si = 0; si < total; si++) {
          if (!isValid(steps[si])) { start = si; break; }
        }
      }
      idx = start;
      paint(false); /* no autofocus on load - never steal focus / scroll */
    })();

    /* ---- ARIA tabs ---- */
    var tabs = [].slice.call(root.querySelectorAll('.wb-tab'));
    function activate(i, focus) {
      tabs.forEach(function (t, j) {
        var p = document.getElementById(t.getAttribute('aria-controls'));
        var on = j === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (p) { p.hidden = !on; }
      });
      if (focus && tabs[i]) { tabs[i].focus(); }
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i, false); });
      t.addEventListener('keydown', function (e) {
        var rtl = (document.documentElement.getAttribute('dir') === 'rtl') || (root.getAttribute('dir') === 'rtl');
        var n = null;
        if (e.key === 'ArrowRight') { n = rtl ? i - 1 : i + 1; }
        else if (e.key === 'ArrowLeft') { n = rtl ? i + 1 : i - 1; }
        else if (e.key === 'Home') { n = 0; }
        else if (e.key === 'End') { n = tabs.length - 1; }
        if (n === null) return;
        e.preventDefault();
        if (n < 0) { n = tabs.length - 1; }
        if (n >= tabs.length) { n = 0; }
        activate(n, true);
      });
    });
    if (tabs.length) { activate(0, false); }

    /* ---- mini CTA bar thumbnail ----
       The bar starts hidden (visibility:hidden), so a loading="lazy" image
       inside it never intersects the viewport and never loads - it rendered
       as an empty white square. Force it to load, and hide the thumb wrapper
       entirely if there is no usable image. */
    var mthumb = bar ? bar.querySelector('.wb-minibar__thumb') : null;
    var mimg = mthumb ? mthumb.querySelector('img') : null;
    if (mthumb && !mimg) { mthumb.hidden = true; }
    if (mthumb && mimg) {
      var msrc = mimg.getAttribute('src');
      if (!msrc) {
        mthumb.hidden = true;
      } else {
        mimg.addEventListener('error', function () { mthumb.hidden = true; });
        mimg.addEventListener('load', function () { if (!mimg.naturalWidth) { mthumb.hidden = true; } });
        mimg.setAttribute('loading', 'eager');
        mimg.setAttribute('decoding', 'async');
        if (!mimg.complete || !mimg.naturalWidth) { mimg.setAttribute('src', msrc); }
      }
    }

    /* ---- sticky offsets + mini CTA bar reveal ----
       The bar is fixed and hidden by default (see wb-pdp.css). It is revealed
       only once the bottom of the hero lead card (the quote panel whose wrapper
       carries id="RfqForm") has scrolled above the bottom of the site header.
       Preferred mechanism is an IntersectionObserver whose root is the viewport
       shrunk from the top by the header height, so no work happens on every
       scroll frame; a scroll listener is used as a fallback when IO is missing.
       --wb-mini mirrors the live height of the bar (0 when hidden) so the
       sticky tab bar and #RfqForm scroll-margin stay correct either way. */
    var lastH = -1, lastM = -1, barOn = null, io = null, ioMargin = null;

    function setBar(on) {
      if (!bar || on === barOn) return;
      barOn = on;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var m = on ? Math.round(bar.getBoundingClientRect().height) : 0;
      if (m !== lastM) { document.documentElement.style.setProperty('--wb-mini', m + 'px'); lastM = m; }
    }

    function ensureObserver(h) {
      if (!('IntersectionObserver' in window)) return false;
      var margin = -(h + 8);
      if (io && ioMargin === margin) return true;
      if (io) { io.disconnect(); }
      ioMargin = margin;
      io = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        var line = e.rootBounds ? e.rootBounds.top : (h + 8);
        setBar(!e.isIntersecting && e.boundingClientRect.bottom <= line);
      }, { root: null, rootMargin: margin + 'px 0px 0px 0px', threshold: 0 });
      io.observe(lead);
      return true;
    }

    function sync() {
      var h = hdrBottom();
      if (h !== lastH) { document.documentElement.style.setProperty('--wb-hdr', h + 'px'); lastH = h; }
      if (!bar || !lead) return;
      if (!ensureObserver(h)) {
        setBar(lead.getBoundingClientRect().bottom <= h + 8);
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', onScroll);
    setBar(false);
    sync();

    /* ---- "Request a Quote" jump links ----
       Both the sticky mini bar and the final CTA band point at #RfqForm, which
       is the .wb-lead wrapper. These are intercepted so the scroll is smooth
       AND so the fragment is never written into the address bar. */
    var jumps = [].slice.call(root.querySelectorAll('.wb-minibar__quote, .wb-band__btn--quote'));
    jumps.forEach(function (jump) {
      jump.addEventListener('click', function (e) {
        var f = document.getElementById('RfqForm');
        if (!f) return;
        e.preventDefault();
        f.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(function () {
          var s = f.querySelector('[data-wb-step]:not([hidden])');
          var i = (s || f).querySelector('input:not([type=hidden]), textarea');
          if (i) { try { i.focus({ preventScroll: true }); } catch (err) { i.focus(); } }
        }, 650);
      });
    });
  });
})();
